// PetJr Brand Colors
export const COLORS = {
  yellow: '#FFE36A', // logo cloud
  yellowDeep: '#FFDE53',
  orange: '#FF9C2A', // logo, accents
  orangeDeep: '#FF7C2A',
  purple: '#7E52C7', // headings, doodles
  purpleBright: '#8A4FF7',
  teal: '#4ED6C4', // bg panels
  tealBright: '#7FE7D1',
  blue: '#4CC9F0',
  pink: '#FFD6E0',
  offWhite: '#FFF9F0', // background
  panel: '#F8F6FF', // panel backgrounds
  accent: '#FFDE53',
  text: '#222',
  gray: '#A389F4',
};

export const BORDER_RADIUS = '18px';
export const PADDING = '24px';
export const FONT_FAMILY = `'Poppins', 'Open Sans', Arial, sans-serif`;
